if (!customElements.get('concept-story-video-gallery')) {
  customElements.define('concept-story-video-gallery', class extends HTMLElement {
    connectedCallback() {
      this.article = this.closest('.concept-story__item');
      this.dialog = this.querySelector('[data-concept-story-video-dialog]');
      this.slides = [...this.querySelectorAll('[data-concept-story-video-slide]')];
      this.count = this.querySelector('[data-concept-story-video-count]');

      if (!this.article || !this.dialog || !this.slides.length) return;

      this.onArticleClick = (event) => {
        const trigger = event.target.closest('[data-concept-story-video-open]');
        if (!trigger || !this.article.contains(trigger)) return;

        this.showSlide(0);
        this.dialog.showModal();
      };

      this.onDialogClick = (event) => {
        if (event.target === this.dialog || event.target.closest('[data-concept-story-video-close]')) {
          this.dialog.close();
        } else if (event.target.closest('[data-concept-story-video-previous]')) {
          this.showSlide(this.currentIndex - 1);
        } else if (event.target.closest('[data-concept-story-video-next]')) {
          this.showSlide(this.currentIndex + 1);
        }
      };

      this.onDialogClose = () => this.pauseVideos();
      this.onVideoContextMenu = (event) => event.preventDefault();

      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (!video) return;
        video.setAttribute('controlslist', 'nodownload');
        video.addEventListener('contextmenu', this.onVideoContextMenu);
      });

      this.article.addEventListener('click', this.onArticleClick);
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('close', this.onDialogClose);
    }

    disconnectedCallback() {
      this.article?.removeEventListener('click', this.onArticleClick);
      this.dialog?.removeEventListener('click', this.onDialogClick);
      this.dialog?.removeEventListener('close', this.onDialogClose);
      this.slides?.forEach((slide) => {
        slide.querySelector('video')?.removeEventListener('contextmenu', this.onVideoContextMenu);
      });
    }

    pauseVideos() {
      this.slides.forEach((slide) => slide.querySelector('video')?.pause());
    }

    showSlide(index) {
      this.pauseVideos();
      this.currentIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== this.currentIndex;
      });

      if (this.count) this.count.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
    }
  });
}
